export * from "./cmsInformations"

export const isCmsConnected = integration => integration.connected
